import React from 'react'

const Footer = () => (
	<footer>
		<p>VPS Proprietary</p>
	</footer>
)

export default Footer
